import React, {Component} from 'react'
import PropTypes from 'prop-types'

class Barcode extends Component {
    render() {
        return (
            <td className='Barcode'>
                {this.props.barcode || '-'}
            </td>
        )
    }
}

Barcode.propTypes = {
    barcode: PropTypes.string.isRequired,
}

export default Barcode
